import { cilArrowLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormSelect,
  CImage,
  CRow,
} from '@coreui/react'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { registerUser } from 'src/redux/registration'
import { useEffect } from 'react'
import { getCountry } from 'src/redux/country'
import { getStates } from 'src/redux/states'
import { getCities } from 'src/redux/cities'
import { getSingleAppUser } from 'src/redux/appusers'
import imgPic from 'src/assets/images/profile.png'

const Editusers = () => {
  const [loading, setLoading] = useState(false)
  const [image, setImage] = useState(null)
  const handleImageChange = (e) => {
    const file = e.target.files[0]
    setImage(URL.createObjectURL(file))
    setFormData({ ...formData, profile: file })
  }

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    mobile_no: '',
    mobile_otp: '',
    mobile_verify: '',
    email_id: '',
    email_otp: '',
    email_verify: '',
    user_type: '',
    name: '',
    whatsapp_no: '',
    country: '',
    state: '',
    city: '',
    address: '',
    residence1_type: '',
    residence1_area: '',
    residence2_type: '',
    residence2_area: '',
    profile_pic: '',
    registration: '',
    is_active: '',
    geolocation: {
      area: '',
      pincode: '',
      coordinates: '',
    },
  })

  const dispatch = useDispatch()
  const { id } = useParams()
  const { singleAppUser } = useSelector((state) => state.appuser)

  useEffect(() => {
    dispatch(getSingleAppUser(id))
  }, [dispatch, id])

  useEffect(() => {
    setFormData(singleAppUser)
  }, [dispatch, singleAppUser])

  const goBack = () => {
    window.history.back()
  }

  const [countryCode, setCountryCode] = useState('')
  const [stateCode, setStateCode] = useState('')

  const { countryData } = useSelector((state) => state.country)
  const { statesData } = useSelector((state) => state.states)
  const { citiesData } = useSelector((state) => state.cities)

  useEffect(() => {
    dispatch(getCountry())
  }, [dispatch])

  useEffect(() => {
    dispatch(getStates(countryCode))
  }, [dispatch, countryCode])

  useEffect(() => {
    dispatch(getCities(`${countryCode}/${stateCode}`))
  }, [dispatch, stateCode])

  const [validated, setValidated] = useState(false)
  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)

    const formDataToSend = new FormData()
    Object.keys(formData).forEach((key) => {
      if (
        key !== 'username' &&
        key !== 'password' &&
        key !== 'mobile_no' &&
        key !== 'mobile_otp' &&
        key !== 'mobile_verify' &&
        key !== 'email_id' &&
        key !== 'email_otp' &&
        key !== 'email_verify' &&
        key !== 'user_type' &&
        key !== 'fcm_token' &&
        key !== 'reset_token' &&
        key !== 'reset_expiry' &&
        key !== 'createdAt' &&
        key !== 'updatedAt' &&
        key !== 'profile_pic'
      ) {
        formDataToSend.append(key, formData[key])
      }
    })
    try {
      await dispatch(registerUser(formDataToSend, id))
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <CContainer>
      <div className="d-flex justify-content-end">
        <CButton color="secondary" size="sm" className="text-white" onClick={() => goBack()}>
          <CIcon icon={cilArrowLeft} className="text-white" /> Go Back
        </CButton>
      </div>

      <CRow className="justify-content-center my-2">
        <CCol md={9} lg={7} xl={12}>
          {id && (
            <CForm
              className="needs-validation"
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >
              <CCard className="px-4 mt-2">
                <CCardBody className="p-4 row g-3">
                  <CCol md={10}>
                    <div className="row g-3">
                      <CCol md={4}>
                        <CFormInput
                          id="name"
                          type="text"
                          label="Full Name"
                          placeholder="Enter name"
                          feedbackInvalid="Please provide a valid name"
                          value={formData?.name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          required
                        />
                      </CCol>

                      <CCol md={4}>
                        <CFormInput
                          id="mobile_no"
                          type="number"
                          label="Mobile Number"
                          placeholder="Enter Mobile Number"
                          feedbackInvalid="Please provide a valid Mobile Number"
                          value={formData?.mobile_no}
                          onChange={(e) => setFormData({ ...formData, mobile_no: e.target.value })}
                          required
                        />
                      </CCol>

                      <CCol md={4}>
                        <CFormInput
                          id="whatsapp_no"
                          type="number"
                          label="WhatsApp Number"
                          placeholder="Enter WhatsApp number"
                          feedbackInvalid="Please provide a valid WhatsApp number"
                          value={formData?.whatsapp_no}
                          onChange={(e) =>
                            setFormData({ ...formData, whatsapp_no: e.target.value })
                          }
                          required
                        />
                      </CCol>

                      <CCol md={4}>
                        <CFormInput
                          id="email_id"
                          type="email"
                          label="Email Address"
                          placeholder="Enter Email Address"
                          feedbackInvalid="Please provide a valid Email Address"
                          value={formData?.email_id}
                          onChange={(e) => setFormData({ ...formData, email_id: e.target.value })}
                          required
                        />
                      </CCol>

                      <CCol md={4}>
                        <CFormInput
                          id="password"
                          type="password"
                          label="Password"
                          placeholder="Enter Password"
                          feedbackInvalid="Please provide a valid Password"
                          value={formData?.password}
                          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                          required
                        />
                      </CCol>

                      <CCol md={4}>
                        <CFormInput
                          id="cpassword"
                          type="password"
                          label="Confirm Password"
                          placeholder="Enter Confirm Password"
                          feedbackInvalid="Please provide a valid Confirm Password"
                          value={formData?.password}
                          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                          required
                        />
                      </CCol>
                    </div>
                  </CCol>
                  <CCol md={2}>
                    <CImage
                      src={image ? image : imgPic}
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 100,
                      }}
                    />
                    <div className="my-4">
                      <CFormInput
                        type="file"
                        size="sm"
                        id="pickImage"
                        onChange={handleImageChange}
                      />
                    </div>
                  </CCol>
                </CCardBody>
              </CCard>
              <CCard className="px-4 mt-2">
                <CCardBody className="p-4 row g-3">
                  <CCol md={3}>
                    <CFormSelect
                      id="country"
                      label="Country"
                      feedbackInvalid="Please provide a valid country"
                      value={formData?.country}
                      onChange={(e) => {
                        countryData?.map(
                          ({ name, isoCode }) => name === e.target.value && setCountryCode(isoCode),
                        )
                        setFormData({
                          ...formData,
                          country: e.target.value,
                          state: '',
                          city: '',
                        })
                      }}
                      required
                    >
                      <option>Select country</option>
                      {countryData?.map(({ name }, index) => (
                        <option value={name} key={index}>
                          {name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CCol md={3}>
                    <CFormSelect
                      id="state"
                      label="State"
                      feedbackInvalid="Please provide a valid state"
                      value={formData?.state}
                      onChange={(e) => {
                        statesData?.map(
                          ({ name, isoCode }) => name === e.target.value && setStateCode(isoCode),
                        )
                        setFormData({
                          ...formData,
                          state: e.target.value,
                          city: '',
                        })
                      }}
                      required
                    >
                      <option>Select state</option>
                      {statesData?.map(({ name }, index) => (
                        <option value={name} key={index}>
                          {name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CCol md={3}>
                    <CFormSelect
                      id="city"
                      label="City"
                      feedbackInvalid="Please provide a valid city"
                      value={formData?.city}
                      onChange={(e) => {
                        citiesData?.map(({ name }) => name === e.target.value)
                        setFormData({
                          ...formData,
                          city: e.target.value,
                        })
                      }}
                      required
                    >
                      <option>Select city</option>
                      {citiesData?.map(({ name }, index) => (
                        <option value={name} key={index}>
                          {name}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>

                  <CCol md={3}>
                    <CFormInput
                      id="address"
                      label="Address"
                      feedbackInvalid="Please provide a valid address"
                      type="text"
                      name="address"
                      value={formData?.address}
                      onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                      placeholder="Enter Address"
                    />
                  </CCol>
                  <CCol md={3}>
                    <CFormInput
                      type="text"
                      name="residence1_type"
                      value={formData?.residence1_type}
                      onChange={(e) =>
                        setFormData({ ...formData, residence1_type: e.target.value })
                      }
                      placeholder="Residence Type 1"
                    />
                  </CCol>
                  <CCol md={3}>
                    <CFormInput
                      type="text"
                      name="residence1_area"
                      value={formData?.residence1_area}
                      onChange={(e) =>
                        setFormData({ ...formData, residence1_area: e.target.value })
                      }
                      placeholder="Residence Area 1"
                    />
                  </CCol>
                  <CCol md={3}>
                    <CFormInput
                      type="text"
                      name="residence2_type"
                      value={formData?.residence2_type}
                      onChange={(e) =>
                        setFormData({ ...formData, residence2_type: e.target.value })
                      }
                      placeholder="Residence Type 2"
                    />
                  </CCol>
                  <CCol md={3}>
                    <CFormInput
                      type="text"
                      name="residence2_area"
                      value={formData?.residence2_area}
                      onChange={(e) =>
                        setFormData({ ...formData, residence2_area: e.target.value })
                      }
                      placeholder="Residence Area 2"
                    />
                  </CCol>

                  <CCol md={12}>
                    <div className="d-flex justify-content-end">
                      <CButton color="success" type="submit" className="text-white mx-2">
                        Update Profile
                      </CButton>
                    </div>
                  </CCol>
                </CCardBody>
              </CCard>
            </CForm>
          )}
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default Editusers
